const getters = {
  getAdditionalFeeRequest: (state) => state.additionalFeeRequest,
  getAdditionalFeeRequestList: (state) => state.additionalFeeRequestList,
  getAdditionalFeeRequestListMeta: (state) => state.additionalFeeRequestMeta,
};

export default getters;
